import React from 'react'
import { Label, Input, FormGroup } from 'reactstrap'
import { Controller, Control, FieldValues, FieldErrors } from 'react-hook-form'
import './ICSCheckBoxInput.css'

const ICSCheckBoxInput = ({
  name,
  id = `${name}Input`,
  control,
  defaultValue = false,
  isSubmitted,
  label,
}: ICSCheckBoxInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, name, ref },
        fieldState: { invalid, isTouched },
      }) => {
        return (
          <FormGroup check>
            <Label for={id} check>
              <Input
                id={id}
                className='ICSCheckBoxInput'
                onBlur={onBlur}
                onChange={onChange}
                type='checkbox'
                valid={!invalid && (isTouched || isSubmitted)}
                invalid={invalid}
                innerRef={ref}
                data-testid={`${name}CheckBoxInput`}
              />
              {label}
            </Label>
          </FormGroup>
        )
      }}
    />
  )
}

export default ICSCheckBoxInput

type ICSCheckBoxInputProps<TFieldValues extends FieldValues = FieldValues> = {
  id?: string
  name: string
  control?: Control<TFieldValues>
  errors?: FieldErrors<TFieldValues>
  defaultValue?: boolean
  isSubmitted?: boolean
  label?: string
  helpText?: string
}
